module.exports = __webpack_public_path__ + "img/12m.e1e18605.png";